export const PIXEL_ID = '1348966334063281';

export function trackInitiateCheckout() {
  window.fbq?.('track', 'InitiateCheckout');
}
